












import { Component, Prop, Vue } from 'vue-property-decorator';

const GoogleMapsApiLoader = require('google-maps-api-loader');

@Component({
  name: 'GeoMapLoader',
  components: {},
})
export default class GeoMapLoader extends Vue {
  @Prop() public mapConfig?: any;

  @Prop() public apiKey?: string;

  protected googleMapApi: any = null;

  protected map: any = null;

  public mounted() {
    this.initializeMap();
  }

  protected async initializeMap() {
    this.googleMapApi = await GoogleMapsApiLoader({
      apiKey: this.apiKey,
    });
    const mapContainer = this.$refs.map;
    this.map = new this.googleMapApi.maps.Map(mapContainer, this.mapConfig);
  }
}

